import { endpoint } from '@library/endpoint'

import routes from 'config/routes'
// TODO: remove when fetch.js converted to ts
// eslint-disable-next-line import/extensions
import { fetch } from 'utils/fetch.js'

/** @deprecated use orderV2.fetchOrder instead */
export function fetchOrder(accessToken: string, orderId: string, reqData = {}) {
  return fetch(accessToken, `${endpoint('core')}/order/${orderId}`, reqData, 'GET', undefined, {
    'Content-Type': 'application/json',
  })
}

/** @deprecated use orderV2.createOrder instead */
export function createPreviewOrder(reqData = {}) {
  return fetch(null, `${endpoint('core')}${routes.core.orderPreview}`, reqData, 'POST')
}

/** @deprecated use orderV2.updateOrder instead */
export function updateOrderItems(accessToken: string, orderId: string, reqData = {}) {
  return fetch(
    accessToken,
    `${endpoint('core')}/order/${orderId}/update-items`,
    reqData,
    'PUT',
    undefined,
    {
      'Content-Type': 'application/json',
    },
  )
}

/** @deprecated use orderV2.createOrder instead */
export function saveOrder(accessToken: string, orderId: string, reqData?: Record<string, unknown>) {
  return fetch(accessToken, `${endpoint('core')}/order/${orderId}`, reqData, 'PUT', undefined, {
    'Content-Type': 'application/json',
  })
}

/** @deprecated use orderV2.cancelPendingOrders instead */
export function cancelExistingOrders(accessToken: string, reqData = {}) {
  return fetch(accessToken, `${endpoint('core')}${routes.core.cancelPending}`, reqData, 'POST')
}

/** @deprecated use orderV2.updateOrder instead */
export function updateOrderAddress(accessToken: string, orderId: string, addressId: string) {
  return fetch(
    accessToken,
    `${endpoint('core')}/order/${orderId}/change-address/`,
    { address_id: addressId },
    'PUT',
    undefined,
    {
      'Content-Type': 'application/json',
    },
  )
}
